<template>
	<div class="container-template">
		<div class="menu-aux" />
		<div class="menu-debits">
			<MenuDebits />
		</div>
		<div class="page-debit">
			<router-view />
		</div>
	</div>
</template>

<script>
import MenuDebits from "./MenuDebits";
import { mapMutations } from "vuex";
export default {
	name: "TemplateDebts",
	components: { MenuDebits },
	methods: {
		...mapMutations(["SET_CPF_CNPJ", "SET_EMPRESAS", "SET_PESSOA"])
	},
	created() {
		window.fbq("trackCustom", "Home");
		if (localStorage.getItem("cpf_cnpj") && localStorage.getItem("pessoa") && localStorage.getItem("empresas")) {
			this.SET_CPF_CNPJ(localStorage.getItem("cpf_cnpj"));
			this.SET_EMPRESAS(JSON.parse(localStorage.getItem("empresas")));
			this.SET_PESSOA(localStorage.getItem("pessoa"));
		}
	}
};
</script>

<style scoped lang="scss">
.container-template {
	box-sizing: border-box;
	width: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: row;
	@media only screen and (max-width: 990px) {
		flex-direction: column;
		height: auto;
	}
}

.menu-debits {
	z-index: 9999;
	box-sizing: border-box;
	width: 35vw;
	/*background-image:url(../../assets/images/background-blue.png);*/
	background-color: #050b17;
	background-size: cover;
	background-position: top center;
	position: fixed;
	@media only screen and (min-width: 990px) {
		min-height: 100vh;
	}
	@media only screen and (max-width: 990px) {
		width: 100%;
		height: 130px;
	}
}

.menu-aux {
	box-sizing: border-box;
	width: 35vw;
	height: 100vh;
	position: relative;
	@media only screen and (max-width: 990px) {
		height: 130px;
	}
}

.page-debit {
	box-sizing: border-box;
	background: #f3f5f9;
	flex: 1;
}
</style>
